var r=/^(?:0|[1-9]\d*)$/;var t=function(t,e){var a=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==a||"symbol"!=a&&r.test(t))&&t>-1&&t%1==0&&t<e};export{t as default};
//# sourceMappingURL=_isIndex.js.map
